enum TransactionStatus {
  CANCELED = "CANCELED",
  CLOSED = "CLOSED",
  COMPLETE = "COMPLETE",
  DECLINED = "DECLINED",
  FAILED = "FAILED",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  PAYMENT_FAIL = "PAYMENT_FAIL",
  PENDING = "PENDING",
  PENDING_BANK_ACCOUNT = "PENDING_BANK_ACCOUNT",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PROCESSING_PAYMENT = "PROCESSING_PAYMENT",
  REFUNDED = "REFUNDED",
  RETURNED = "RETURNED",
  REVERSED = "REVERSED",

  PERSONAL_PENDING = "PERSONAL_PENDING",
  PERSONAL_PROCESSING = "PERSONAL_PROCESSING",
  PERSONAL_COMPLETE = "PERSONAL_COMPLETE",
  PERSONAL_FAILED = "PERSONAL_FAILED",
  PERSONAL_REFUNDED = "PERSONAL_REFUNDED",

  REFUND_PENDING = "REFUND_PENDING",
  REFUND_SUCCESS = "REFUND_SUCCESS",
  REFUND_FAIL = "REFUND_FAIL",
  REFUND_CANCELED = "REFUND_CANCELED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
}

export default TransactionStatus;
